import { ActionTypes } from './actions';

const initialState = {
  isLoading: false,
  data: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCHING:
      return { ...state, isLoading: true };
    case ActionTypes.FETCHED:
      return { isLoading: false, data: action.data.data };
    default:
      return state;
  }
};
